import Icon from "../../Icon/Icon";
import {INPUT_ICON_ACCESSIBILITY_TEXT} from "../utils";
import React from "react";

export function RenderClearIcon(props) {
  const {intl, onIconClick} = props;
  return <div className={"InputField__icon_wrapper"} onMouseDown={onIconClick}>
    <Icon
      className="InputField__icon_svg"
      desc={intl.formatMessage(INPUT_ICON_ACCESSIBILITY_TEXT.desc)}
      id="InputField__close_icon"
      name="close"
      title={intl.formatMessage(INPUT_ICON_ACCESSIBILITY_TEXT.title)}
      styles={{width: "12px", height: "12px", fill: "#677383"}}
    />
  </div>;
}
